import { SCHEMA_MAP } from "./schema";
import type { Availability, ClientConfig, RegistryEntry, SiteId } from "./types";

function isAvailable(av: Availability | undefined, site: SiteId): boolean {
  if (!av) return true;
  if ("only" in av) return av.only.includes(site);
  return !av.except.includes(site);
}

export function buildRegistry(config: ClientConfig): RegistryEntry[] {
  const site = config.SITE_OPTION;
  const { hide = [], show = [], lock = [] } = config.settings ?? {};

  return Object.entries(SCHEMA_MAP)
    .filter(([key, def]) => {
      if (hide.includes(key)) return false;
      if (show.includes(key)) return true;
      return isAvailable(def.availability, site);
    })
    .map(([key, def]) => ({ key, def, locked: lock.includes(key) }))
    .sort((a, b) => (a.def.group ?? "").localeCompare(b.def.group ?? "") || (a.def.order ?? 0) - (b.def.order ?? 0));
}
